module.exports = __webpack_public_path__ + "img/safemoon.17d96d80.svg";